import React from "react";

const Contactfooter = () => {
  return (
    <div>
      <div className="bg-gray-300 flex md:flex-row flex-col justify-center items-center md:pt-20 pt-10 px-10 md:gap-52">
        <div className="md:h-40 h-20 justify-center items-center text-center animate-moveUpDown">
          <h1 className="md:text-5xl text-2xl font-bold font-dancing">
            Contact Us
          </h1>
          <div className="w-64 text-red-800 md:mt-5 mt-2 px-2">
            We are just one call away!
          </div>
        </div>
      </div>

      {/* Tailwind CSS Keyframe Animation */}
      <style>
        {`
          @keyframes moveUpDown {
            0% { transform: translateY(0); }
            50% { transform: translateY(-10px); }
            100% { transform: translateY(0); }
          }
          .animate-moveUpDown {
            animation: moveUpDown 2s ease-in-out infinite;
          }
        `}
      </style>
    </div>
  );
};

export default Contactfooter;
